import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import WhatsInAName from '@/views/About/WhatsInAName.vue';
import MenOfTheMarauders from '@/views/About/MenOfTheMarauders.vue';
import CongressionalGoldMedal from '@/views/About/CongressionalGoldMedal.vue';
import ContactInformation from '@/views/About/ContactInformation.vue';
import PastReunions from '@/views/Events/PastReunions.vue';
import Home from '@/views/Home/Home.vue';
import BurmanNews from '@/views/Links/BurmanNews.vue';
import WebsitesBooksVideos from '@/views/Links/WebsitesBooksVideos.vue';
import InspirationAndTributes from '@/views/Links/InspirationAndTributes.vue';
import HowToRequestMilitaryMedals from '@/views/Links/HowToRequestMilitaryMedals.vue';
import MarauderPhotoAlbums from '@/views/Photos/MarauderPhotoAlbums.vue';
import ThenAndNow from '@/views/Photos/ThenAndNow.vue';
import Press from '@/views/Press/Press.vue';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/about/whats-in-a-name-from-galahad-to-mars-task-force',
        name: 'whatsInAName',
        component: WhatsInAName
    },
    {
        path: '/about/men-of-the-marauders',
        name: 'menOfTheMarauders',
        component: MenOfTheMarauders
    },
    {
        path: '/about/congressional-gold-medal-campaign',
        name: 'congressionalGoldMedal',
        component: CongressionalGoldMedal
    },
    {
        path: '/about/contact-information',
        name: 'contactInformation',
        component: ContactInformation
    },
    {
        path: '/events/past-reunions',
        name: 'pastReunions',
        component: PastReunions
    },
    {
        path: '/photos/then-and-now',
        name: 'thenAndNow',
        component: ThenAndNow
    },
    {
        path: '/photos/marauder-photo-albums',
        name: 'marauderPhotoAlbums',
        component: MarauderPhotoAlbums
    },
    {
        path: '/press',
        name: 'press',
        component: Press
    },
    {
        path: '/links/burman-news',
        name: 'burmanNews',
        component: BurmanNews
    },
    {
        path: '/links/websites-books-videos',
        name: 'websitesBooksVideos',
        component: WebsitesBooksVideos
    },
    {
        path: '/links/inspiration-and-tributes',
        name: 'inspirationAndTributes',
        component: InspirationAndTributes
    },
    {
        path: '/links/how-to-request-military-medals',
        name: 'howToRequestMilitaryMedals',
        component: HowToRequestMilitaryMedals
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
